import { render, staticRenderFns } from "./receiveCoupon.vue?vue&type=template&id=3399ced6&scoped=true&"
import script from "./receiveCoupon.vue?vue&type=script&lang=js&"
export * from "./receiveCoupon.vue?vue&type=script&lang=js&"
import style0 from "./receiveCoupon.vue?vue&type=style&index=0&id=3399ced6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3399ced6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/mnt/jenkins/workspace/product_operation/package_operation-saasmobile/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3399ced6')) {
      api.createRecord('3399ced6', component.options)
    } else {
      api.reload('3399ced6', component.options)
    }
    module.hot.accept("./receiveCoupon.vue?vue&type=template&id=3399ced6&scoped=true&", function () {
      api.rerender('3399ced6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/receiveCoupon.vue"
export default component.exports